// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutMain_root__P3b3C"};